<template>

  <div>
    <h1>Sensores</h1>
<!--    <div class="sensores">-->
<!--      <div class="mt-5">-->
<!--        <i class="fas fa-temperature-low"></i> Temperatura <span>{{registro.temperatura}}</span>-->
<!--      </div>-->
<!--      <div class="mt-5">-->
<!--        <i class="fas fa-tint"></i> Humedad <span>{{registro.humedad}}</span>-->
<!--      </div>-->
<!--      <div class="mt-5">-->
<!--        <i class="fas fa-cloud"></i> CO2 <span>{{registro.co2}}</span> <span> ppm</span>-->
<!--      </div>-->
<!--      <div class="mt-5">-->
<!--        <i class="fas fa-atom"></i> TVOC <span>{{registro.tvoc}}</span>-->
<!--      </div>-->
<!--    </div>-->



    <div class="container d-flex justify-content-center">
      <div class="weather">
        <div class="row">
          <div class=" col-md-6">
            <div class="card"> <span class="icon"><img src="https://img.icons8.com/external-others-aquariid/80/000000/external-climate-weather-others-aquariid-57.png"/></span>
              <div class="title">
                <p>Temperatura</p>
              </div>
              <div class="temp">{{registro.temperatura}}<sup>&deg;</sup></div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="card"> <span class="icon"><img src="https://img.icons8.com/office/80/000000/humidity.png"/></span>
              <div class="title">
                <p>Humedad</p>
              </div>
              <div class="temp">{{registro.humedad}}<span> %</span></div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="card"> <span class="icon"><img src="https://img.icons8.com/fluency/96/000000/co2.png"/></span>
              <div class="title">
                <p>Calidad del Aire</p>
              </div>
              <div class="temp">{{registro.co2}}<span> ppm</span></div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="card"> <span class="icon"><img src="https://img.icons8.com/color/96/000000/gas.png"/></span>
              <div class="title">
                <p>Volatilidad</p>
              </div>
              <div class="temp">{{registro.tvoc}}<span> ppb</span></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>

</template>

<script>
import { io } from 'socket.io-client'
import {onMounted, ref} from "vue"
import axios from 'axios'

export default {
  setup() {
    // const url = 'http://143.198.140.70:3000/api/sensores/61e3a7aa9393f7987b39d555'
	  const url = 'https://sensores.leksilab.com/demo/api/sensores/61e3a7aa9393f7987b39d555'
    const registro = ref({
      temperatura: '',
      humedad: '',
      co2: '',
      tvoc: ''
    })
    onMounted(() => {
      // const socket = io('https://143.198.140.70:3000')
      // {secure: true}
	    const socket = io('https://sensores.leksilab.com')
	  

      socket.on('connect', () => {
        console.log('Conectado al servidor');
        // this.socketStatus = true;
      });

      socket.on( 'creado', () => {
        console.log('Evento: registro creado');
        // Subscriber.next(data);
      });

      socket.on( 'actualizado', () => {
        //console.log('Evento: registro actualizado');
        // Subscriber.next(data);
        //console.log('URL: ', url)
        axios
            .get(url)
            .then(response => {
              registro.value.temperatura = response.data.data.temperatura
              registro.value.humedad = response.data.data.humedad
              registro.value.co2 = response.data.data.co2
              registro.value.tvoc = response.data.data.tvoc
            })
      });

    })

    return {registro}
  }
}
</script>

<style scoped>
.sensores{
  display: flex;
  flex-direction: column;
}
.mt-5 {
  margin-top: 20px;
}


body {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(238, 237, 237, 0.33);
  color: rgb(105, 104, 104);
  font-family: sans-serif
}

.container {
  height: 80vh;
  background-color: #ffffff;
  border-color: #ffffff;
  align-items: center;
  border-radius: 1rem;
  vertical-align: middle
}

@media(max-width:767px) {
  .container {
    height: fit-content
  }
}

.weather {
  width: 77%
}

@media(max-width:767px) {
  .weather {
    width: 100%
  }
}

.card {
  padding: 1rem;
  margin: 1.5rem 4vw;
  border-radius: 1rem;
  background-color: rgba(238, 237, 237, 0.22);
  border-color: rgba(238, 237, 237, 0.22);
  box-shadow: 5px 6px 6px 2px #e9ecef;
  text-align: center
}

@media(max-width:768px) {
  .card {
    margin: 1.5rem
  }
}

.title {
  justify-content: center;
  position: absolute;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%)
}

.title p {
  margin-bottom: 0.2rem;
  font-size: 1.2rem
}

.temp {
  font-size: 2.6rem;
  margin-bottom: 1rem
}

.header {
  color: #dddddd
}

.col-4 {
  padding: 0 0.2rem
}

.icon {
  align-self: flex-end;
  margin-right: -2.5rem;
  margin-top: -2rem;
  z-index: 999
}

.icon img {
  width: 5rem
}
</style>
